import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {BulletinBoardPost} from '@app/core/models/bulletinBoardPost.model';
import {
	DislikePost,
	GetBulletinPostComments,
	GetPostSeenByInfo,
	GetPunchBulletinBoardPostComments,
	GetPunchBulletinBoardPostInfoSeenBy,
	LikePost,
	SetSelectedPostForComments,
} from '@app/core/store/actions/bulletin-board.actions';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {EQOColor, EQOIcon, EQORebrandColor, EQORebrandIcon} from '@quickorder/angular-web-lib';
import {Router} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {selectBulletinBoardCommentsPagination, selectSelectedPostIdForComments} from '@app/core/store/selectors/bulletin-board.selectors';
import {Pagination} from '@app/core/models/pagination.model';
import {BulletinBoardPostLikesInfoComponent} from '@app/modules/shared/components/bulletin-posts/components/bulletin-board-post-likes-info/bulletin-board-post-likes-info.component';
import {MatDialog} from '@angular/material/dialog';
import {BulletinBoardPostSeenByInfoComponent} from '@app/modules/shared/components/bulletin-posts/components/bulletin-board-post-seen-by-info/bulletin-board-post-seen-by-info.component';
import {trackById} from '@app/core/helpers';

@Component({
	selector: 'app-single-bulletin-board-post',
	templateUrl: './single-bulletin-board-post.component.html',
	styleUrls: ['./single-bulletin-board-post.component.scss'],
})
export class SingleBulletinBoardPostComponent implements OnInit, OnDestroy {

	public ICON = EQOIcon;

	public COLOR = EQOColor;
	public EQORebrandIcon: typeof EQORebrandIcon = EQORebrandIcon;
	public EQORebrandColor: typeof EQORebrandColor = EQORebrandColor;

	@Input() public bulletinBoardPost: BulletinBoardPost;

	@Input() public canLike: boolean = true;
	@Input() public showComments: boolean = true;
	@Input() public showAllPosts: boolean = true;
	@Input() public contentPadding: number = 0;

	@Input() public canNavigate: boolean = true;
	@Input() public punchUser: boolean = false;

	public selectedPostForComment$: Observable<number> = this.store.select(selectSelectedPostIdForComments);
	public commentsPagination$: Observable<Pagination> = this.store.select(selectBulletinBoardCommentsPagination);

	public commentsPagination: Pagination;
	public selectedPostId: number;

	public trackById = trackById;

	private _subscriptions: Subscription[] = [];

	constructor(
		private store: Store<IAppState>,
		private router: Router,
		private dialog: MatDialog,
	) {
	}

	public ngOnInit(): void {
		this._subscriptions.push(
			this.selectedPostForComment$.subscribe(id => {
				this.selectedPostId = id;
			}),
			this.commentsPagination$.subscribe(pagination => {
				if (pagination) {
					this.commentsPagination = pagination;
				}
			}),
		);
	}

	public likeOrDislikePost(post: BulletinBoardPost): void {
		if (post.liked) {
			this.store.dispatch(new DislikePost(post));
		} else {
			this.store.dispatch(new LikePost(post));
		}
	}

	public goToBulletinBoard(): void {
		if (!this.canNavigate) {
			return;
		}
		this.router.navigate(['home/opslagstavlen']);
	}

	public getMoreComments(bulletinBoardPost: BulletinBoardPost): void {
		if (this.selectedPostId === bulletinBoardPost.id) {
			if (this.punchUser) {
				this.store.dispatch(new GetPunchBulletinBoardPostComments(10, this.commentsPagination.current_page + 1, bulletinBoardPost.id));
			} else {
				this.store.dispatch(new GetBulletinPostComments(10, this.commentsPagination.current_page + 1, bulletinBoardPost.id));
			}
		} else {
			this.store.dispatch(new SetSelectedPostForComments(bulletinBoardPost.id));
			if (this.punchUser) {
				this.store.dispatch(new GetPunchBulletinBoardPostComments(10, 1, bulletinBoardPost.id));
			} else {
				this.store.dispatch(new GetBulletinPostComments(10, 1, bulletinBoardPost.id));
			}
		}
	}

	public getInfoSeenBy(boardPost: BulletinBoardPost): void {
		if (boardPost.seen_by_count === 0) {
			return;
		}
		if (this.punchUser) {
			this.store.dispatch(new GetPunchBulletinBoardPostInfoSeenBy(boardPost));
		} else {
			this.store.dispatch(new GetPostSeenByInfo(boardPost));
		}
		this.dialog.open(BulletinBoardPostSeenByInfoComponent, {
			panelClass: 'fullscreen-dialog-max-s',
		});

	}

	public getInfoLikedBy(boardPost: BulletinBoardPost): void {
		if (boardPost.message_board_post_likes_count === 0) {
			return;
		}
		this.dialog.open(BulletinBoardPostLikesInfoComponent, {
			panelClass: 'fullscreen-dialog-max-s',
			data: {
				post: boardPost,
				punchClock: this.punchUser,
				likes: boardPost.message_board_post_likes_count,
			},
		});

	}

	public ngOnDestroy(): void {
		this._subscriptions.forEach(s => s.unsubscribe());
		this.store.dispatch(new SetSelectedPostForComments(undefined));
	}
}
